import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { cn } from '@utils/cn';
import { forwardRef } from 'react';

import { type TooltipContentProps, type TooltipContentRef } from './types';

const TooltipContent = forwardRef<TooltipContentRef, TooltipContentProps>(
  ({ className, sideOffset = 4, ...props }, ref) => (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        ref={ref}
        sideOffset={sideOffset}
        className={cn(
          'z-50 overflow-hidden rounded-md border border-border px-3 py-1.5 text-xs',
          'bg-muted text-foreground',
          'animate-in fade-in-0 zoom-in-95',
          'data-[state=closed]:animate-out',
          'data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95',
          'data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2',
          'data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
          className,
        )}
        {...props}
      />
    </TooltipPrimitive.Portal>
  ),
);

TooltipContent.displayName = TooltipPrimitive.Content.displayName;

export { TooltipContent };
